const INDEXATION = {
  title: 'Gestion de l\'inflation',
  breadcrumb: {
    title: 'Gestion de l\'inflation',
  },
  onglet: {
    produit: 'Produits',
    regies: 'Régies',
    client: 'Clients',
  },
  noAnneeSelect: 'Aucune année sélectionnée',
  selectAnnee: 'Sélectionnez une année',
  actions: {
    continuWithoutSave: 'Continuer sans sauvegarder',
    saveAndContinu: 'Sauvegarder et continuer',
  },
  popUpAlerteSauvegarde: {
    titleChange: 'Voulez-vous sélectionner une autre année ?',
    titleCreate: 'Voulez-vous créer une nouvelle année ?',
    sousTitle: 'Toutes modifications apportées sur l\'année {year} seront perdues',
  },
  popUpAddIndexation: {
    title: 'Ajouter une nouvelle année',
    year: 'Année',
    dateDebut: 'Date de début',
    dateFin: 'Date de fin',
  },
  edit: {
    labelDateIndexation: 'Date d\'indice',
    labelValueIndexation: 'Valeur d\'indice',
  },
  year: 'Année de l\'inflation',
  addYear: 'Créer une nouvelle année',
  tauxGeneral: 'Taux général',
  taux: 'Taux',
  tauxWithYear: 'Taux {year}',
  produit: {
    produit: {
      applicableLocation: 'Location',
      applicableTlpe: 'TLPE',
      applicableHonoraire: 'Honoraire',
      applicableDivers: 'Divers',
    },
    tab: {
      select: 'Sélectionner les produits sur lesquels vous souhaitez appliquer l’inflation.',
    },
  },
  regie: {
    tab: {
      regie: 'Régie',
      taux: 'Taux {year} (%)',
      tauxPerso: 'Taux personnalisé',
    },
    popUpGeneration: {
      title: 'Etes-vous sûr de vouloir re-générer l\'inflation pour toutes les régies ?',
      sousTitle: 'Tous les taux ainsi que les taux personnalisés seront écrasés',
    },
    popUpInflationClient: {
      title: '{regie} : Inflation par client',
      tab: {
        client: 'Client',
        taux: 'Taux',
      },
      addClient: 'Ajouter un client',
    },
  },
  client: {
    tab: {
      client: 'Client',
      taux: 'Taux {year} (%)',
    },
    popUpGeneration: {
      title: 'Etes-vous sûr de vouloir re-générer le taux d\'inflation pour tous les clients ?',
      sousTitle: 'Tous les taux seront écrasés',
    },
  },
  message: {
    success: {
      update: 'Inflation modifiée avec succès',
      create: 'Inflation créée avec succès',
      generationRegie: 'Inflation pour les régies générées avec succès',
      generationClient: 'Inflation pour les client générées avec succès',
    },
    error: {
      periodeAlreadyInYear: 'La période sélectionnée est déjà dans une autre année d\'inflation',
      yearAlreadyExist: 'L\'année d\'inflation existe déjà pour la société',
      fournisseurAlreadyInIndexation: 'La régie est déjà renseigné dans l\'année d\'inflation',
      clientAlreadyInIndexation: 'Le client est déjà renseigné dans l\'année d\'inflation',
      clientSpecialisationAlreadyInIndexation: 'Le client est déjà renseigné dans l\'année d\'inflation pour une régie',
    },
  },
};

export default INDEXATION;
